import { ITemplateScope } from "AngularFormly";
import { WorkItemController } from "../../workItemController";
import { Field } from "../../../../model/ProcessApi";
import { INgModelController } from "angular";

export class ListFieldController {
  static $inject = ["$scope"];
  protected originalValue: any;

  constructor(protected readonly $scope: ITemplateScope) {
    (<any>this.$scope).listFieldController = this;
    this.setInitialValue(this.value);
  }

  protected setInitialValue(value: any) {
    this.originalValue = value;
  }

  get value() {
    return this.$scope.model
      ? this.$scope.model[this.$scope.options.key]
      : undefined;
  }

  valueHasChanged(): boolean {
    return this.value !== this.originalValue;
  }

  get workItemController(): WorkItemController {
    return <WorkItemController>this.$scope.options?.data?.workItemController;
  }

  get field(): Field {
    return this.$scope.options.data.field;
  }

  get id(): string {
    return (<any>this.$scope.options).id;
  }

  get formField(): INgModelController {
    return this.$scope.form[this.id];
  }

  editItem() {
    this.workItemController.fireCommand("updateListItem", this.$scope.model);
  }
}
